import * as React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import forms from 'modules/surveys/store/collections/forms'
import Form from 'modules/surveys/store/models/Form'

export function useForm(formId: string): {
  loading: boolean
  form: Form | null | undefined
} {
  const [form, setForm] = React.useState(forms.get(formId))

  const { loading } = useAsyncData(async () => {
    if (form) return

    const fetchedForm = await Form.fetch({ id: String(formId) })
    forms.add(fetchedForm)
    setForm(fetchedForm)
  }, [formId])

  return {
    loading,
    form,
  }
}
